var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"院内机构等级","request":_vm.request,"table-size":"large","column-list":_vm.columnList,"form-parms-add":_vm.formParmsAdd,"tableActionsWidth":100,"form-parms-update":_vm.formParmsUpdate,"table-actions-fixed":true,"need-data-file":true},on:{"dataUpdate":_vm.dataUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }